/* eslint-disable eqeqeq */
/* react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const PairingPage = (props) => {
  const {
   
  } = props;
  const [channel,setChannel] =useState('');
  const [event,setEvent] =useState('');
  const [provider,setProvider] =useState('soketi');
  const [connectionStatus,setConnectionStatus] =useState(false);

  useEffect(() => {
      
  }, []);
  const handlerChannelOnChange=(e)=>{
    setChannel(e.target.value);
  }
  const handlerEventOnChange=(e)=>{
    setEvent(e.target.value);
  }
  const handlerOnConnect=()=>{
    console.log("Starting connection to provider",provider," on channel",channel,"and event", event);
    let socket_key;
    
    if(provider=="soketi")
      socket_key=process.env.REACT_APP_WEBSOCKET_SOKETI_KEY;
    else
      socket_key=process.env.REACT_APP_PUSHER_KEY;

    console.log(socket_key);
    let websocketUrl=process.env.REACT_APP_WEBSOCKET_SOKETI;
    if(provider=="soketi"){
      websocketUrl=process.env.REACT_APP_WEBSOCKET_SOKETI;
    }else if(provider=="laravel"){
      websocketUrl = process.env.REACT_APP_WEBSOCKET;
    }
    window.Pusher = Pusher;
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: socket_key,
      wsHost: websocketUrl,
      disableStats: true,
      encrypted: true,
      enabledTransports: ['ws', 'wss'], // <-- only use ws and wss as valid transports
    });

    window.Echo.channel(channel).listen(`.`+event, (e) => {
      // bindEvent(e));
      console.log("response from socket", e);
    });

    setConnectionStatus(true);
  }
  const handlerOnDisconnect=()=>{
    console.log("Disconnect socket");
    setConnectionStatus(false);
    window.Echo.disconnect();
  }
  const handlerProviderChange=(e)=>{
    setProvider(e.target.value);
  }
  return (
    <div>
        <div> Websocket test</div>
        {!connectionStatus && <div>
          <label>Provider</label><select name="select" defaultValue="soketi" onChange={handlerProviderChange}>
                <option value="soketi" >Soketi</option>
                <option value="laravel">Laravel</option>
                
          </select>
          <br/><br/>
          <label>Channel</label><input type="text" name="channel" value={channel} onChange={handlerChannelOnChange} />
          <br/>
          <label>Event</label><input type="text" name="event" value={event} onChange={handlerEventOnChange}/>
          <button onClick={handlerOnConnect}>Connect</button>
          </div>
        }
        {connectionStatus && <div>Connected to channel={channel} and event={event}</div>}
        {connectionStatus &&<button onClick={handlerOnDisconnect} color="#ff0000">Disconnect</button>}
    </div>
  )
    
};

export default PairingPage;